const fieldConfiguration = {
    'string': {
        50: 'textfield',
        128: 'textfield',
        250: 'textarea',
        1000: 'textarea',
        'default': 'textfield'
    },
    'integer': {
      'default': 'textfield'
    },
    'image upload': {
        100: 'image',
    },
}

export default fieldConfiguration;